import type { PhaseEntry } from 'app/views/home/webgl/particlesOptimised/departments/phases.types';
import type { LinesPhase } from 'app/views/home/webgl/particlesOptimised/departments/systems/phases/LinesPhase';

/**
 * The systems show, in order, with timings — THE place to reorder, re-time
 * or add systems phases (uniform with spaces/spacesPhaseEntries.ts: every
 * department answers "where is the phase list" the same way). One class per
 * phase lives in ./phases/; `frames` is the phase's duration in the
 * department's stage-counter domain (systems counts PLAIN frames — the
 * reference counter is a bare increment, not deltaTime-normalised).
 *
 * A single entry on purpose: the reference stage table is
 * [SingleLine x 10000 frames] — one phase looping onto itself. The in-stage
 * line-mode and marker-colour cycles are internal variation of that phase
 * (they mutate config consumed by persistent in-flight lines), not phases —
 * see LinesPhase's header. The department constructs the LinesPhase (it also
 * routes physics lerp-completions into it) and hands it in.
 */
export function createSystemsPhaseEntries(linesPhase: LinesPhase): Array<PhaseEntry> {
	return [{ phase: linesPhase, frames: 10000 }];
}
